<template lang="pug">

  div(class="firma-dialog-container")

    //- HEADER
    CustomDialogHeaderComponent(:headerTitle="texts.title")

    p(class="explanation") {{ texts.explanation }}

    InfoBarComponent(
      v-if="!isDMSUser"
      :infoText="texts.infoText"
    )

    span(class="required-fields-advice-base") {{ $t('components.form_generator.required_fields') }}

    ReceiverFieldSelectComponent(
        v-if="!isDMSUser"
        @emit-receiver="setReceiver"
      )

    ValidationObserver(
        v-if="isDMSUser"
        ref="emailInput"
        v-slot="{ validate }"
      )

      LexonTextFieldComponent(
        v-model="email"
        label="Email"
        id="email"
        name="email"
        type="text"
        validationRules="required|email"
        @input="validateField"
      )

    LexonSwitchComponent(
      v-model="firmaSwitch"
      :class="['switch-field', { 'error-type': showErrorBar }]"
      id="switch"
      :label="texts.firmaSwitchLabel"
      name="switch"
      hide-details
    )

    //- BUTTONS
    CustomDialogActionButtonsComponent(
      :disabledButtons="disabledActionButton"
      :mainAction="signFirma"
      :primaryButtonText="texts.primaryButtonText"
    )

    //- SPINNER
    SpinnerLayerComponent(v-if="loadingSpinner" class="spinner-layer" :loadingText="spinnerText.sending")

</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import FirmaDialogsMixin from '@/mixins/firma/FirmaDialogsMixin.vue'
import { InfoBarTypes } from '@/components/InfoBar/types/InfoBarComponentTypes'
import { ValidationObserver } from 'vee-validate'

@Component({
  components: {
    CustomDialogActionButtonsComponent: () =>
      import('@/components/Dialog/CustomDialog/CustomDialogActionButtonsComponent.vue'),
    CustomDialogHeaderComponent: () => import('@/components/Dialog/CustomDialog/CustomDialogHeaderComponent.vue'),
    InfoBarComponent: () => import('@/components/InfoBar/InfoBarComponent.vue'),
    LexonTextFieldComponent: () => import('@/components/forms/fields/LexonTextField/LexonTextFieldComponent.vue'),
    LexonSwitchComponent: () => import('@/components/forms/fields/LexonSwitch/LexonSwitchComponent.vue'),
    ReceiverFieldSelectComponent: () =>
      import('@/components/Dialog/customDialogs/firma/ReceiverFieldSelectComponent.vue'),
    SpinnerLayerComponent: () => import('@/components/Spinner/SpinnerLayerComponent.vue'),
    ValidationObserver
  }
})
export default class SendCertifiedEmailFirmaDialogComponent extends Mixins(FirmaDialogsMixin) {
  email = ''
  texts = {
    explanation: this.$t('components.firma_dialogs.send_certified_email.explanation'),
    firmaSwitchLabel: this.$t('components.firma_dialogs.send_certified_email.firma_switch'),
    primaryButtonText: this.$t('action_buttons.send'),
    title: this.$t('components.firma_dialogs.send_certified_email.title'),
    infoText: this.$t('components.firma_dialogs.send_certified_email.info_text'),
    errorText: this.$t('components.firma_dialogs.send_certified_email.error_text')
  }
  $refs!: {
    emailInput: InstanceType<typeof ValidationObserver>
  }

  errorBar = InfoBarTypes.ERROR

  showErrorBar = false

  mounted() {
    if (this.isDMSUser) {
      this.texts.explanation = this.$t('components.firma_dialogs.send_certified_email.explanation_dms')
    }
  }

  async validateField() {
    await this.$nextTick()
    const fieldValid = await this.$refs.emailInput.validate()
    if (fieldValid) {
      this.setReceiver(this.email)
    } else {
      this.setReceiver('')
    }
  }
}
</script>
